export default __webpack_public_path__ + "images/process_2.svg?7078bdf8a046de502d8c691022553347";